import { render, staticRenderFns } from "./NextCallsPopUp.component.vue?vue&type=template&id=67880ff4&scoped=true&"
import script from "./NextCallsPopUp.component.vue?vue&type=script&lang=js&"
export * from "./NextCallsPopUp.component.vue?vue&type=script&lang=js&"
import style0 from "./NextCallsPopUp.component.vue?vue&type=style&index=0&id=67880ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67880ff4",
  null
  
)

export default component.exports